import dayjs from "dayjs";

export const formatDateParam = (date) => {
  if (!date) return undefined;
  if (typeof date === "string") return date.split("T")[0];
  if (date.format) return date.format("YYYY-MM-DD");
  return date;
};

const capEndToToday = (end, now) => (end.isAfter(now) ? now : end);

export const PRESET_DATE_RANGE_TYPES = new Set([
  "today",
  "yesterday",
  "lastWeek",
  "thisWeek",
  "thisMonth",
  "lastMonth",
  "thisYear",
]);

export const resolveDateRangeParams = (filters) => {
  if (!filters?.dateRangeType || filters.dateRangeType === "allTime") {
    return { dateRangeType: "allTime" };
  }

  const now = dayjs().endOf("day");
  let start;
  let end;

  switch (filters.dateRangeType) {
    case "today":
      start = now.startOf("day");
      end = now;
      break;
    case "yesterday":
      start = now.subtract(1, "day").startOf("day");
      end = now.subtract(1, "day").endOf("day");
      break;
    case "lastWeek":
      start = now.subtract(7, "day").startOf("day");
      end = now.subtract(1, "day").endOf("day");
      break;
    case "thisWeek":
      start = now.startOf("week");
      end = now;
      break;
    case "thisMonth":
      start = now.startOf("month");
      end = capEndToToday(now.endOf("month"), now);
      break;
    case "lastMonth":
      start = now.subtract(1, "month").startOf("month");
      end = now.subtract(1, "month").endOf("month");
      break;
    case "thisYear":
      start = now.startOf("year");
      end = capEndToToday(now.endOf("year"), now);
      break;
    case "custom":
      if (filters.customDateRange?.length === 2) {
        start = dayjs(filters.customDateRange[0]).startOf("day");
        end = capEndToToday(dayjs(filters.customDateRange[1]).endOf("day"), now);
      }
      break;
    default:
      return { dateRangeType: filters.dateRangeType };
  }

  if (!start?.isValid?.() || !end?.isValid?.()) return {};

  if (start.isAfter(now)) start = now.startOf("day");
  if (start.isAfter(end)) return {};

  return {
    dateRangeType: filters.dateRangeType,
    startDate: start.format("YYYY-MM-DD"),
    endDate: end.format("YYYY-MM-DD"),
  };
};

const CANONICAL_NATIVE_RANGE_TYPES = new Set([
  "thisWeek",
  "lastWeek",
  "thisMonth",
  "lastMonth",
  "thisYear",
]);

export const buildCanonicalQueryParams = (params = {}) => {
  const { filters, ...rest } = params;
  if (!filters?.dateRangeType) return { ...rest };

  const type = filters.dateRangeType;

  if (type === "allTime") {
    return { dateRangeType: "allTime", ...rest };
  }

  if (CANONICAL_NATIVE_RANGE_TYPES.has(type)) {
    return { dateRangeType: type, ...rest };
  }

  const resolved = resolveDateRangeParams(filters);
  if (resolved.dateRangeType === "allTime") {
    return { dateRangeType: "allTime", ...rest };
  }

  if (resolved.startDate && resolved.endDate) {
    return {
      dateRangeType: "custom",
      startDate: resolved.startDate,
      endDate: resolved.endDate,
      ...rest,
    };
  }

  return { dateRangeType: type, ...rest };
};

export const buildTableDateFilterParams = (filters) => {
  if (!filters?.dateRangeType) return {};
  if (filters.dateRangeType === "allTime") return { dateRangeType: "allTime" };

  const resolved = resolveDateRangeParams(filters);
  if (!resolved.startDate || !resolved.endDate) {
    return { dateRangeType: filters.dateRangeType };
  }

  return {
    dateRangeType: filters.dateRangeType === "custom" ? "custom" : filters.dateRangeType,
    startDate: resolved.startDate,
    endDate: resolved.endDate,
  };
};
